import {createAction} from '@reduxjs/toolkit';

export const getDashboardsConfigurationRequest = createAction('GET_DASHBOARDS_CONFIGURATIONS_REQUEST');
export const getDashboardsConfigurationSuccess = createAction(
    'GET_DASHBOARDS_CONFIGURATIONS_SUCCESS',
);
export const getDashboardsConfigurationFail = createAction('GET_DASHBOARDS_CONFIGURATIONS_FAIL');


export const setDashboardsDateStart = createAction('SET_DASHBOARDS_DATE', function prepare(startDate) {
    return {
        payload: {
            startDate,
        },
    };
});


export const setDashboardsDateEnd= createAction('SET_DASHBOARDS_DATE', function prepare(endDate) {
    return {
        payload: {
            endDate,
        },
    };
});
